"use client";

import { JobMeta, useJobsStore } from "@/stores/jobs-store";
import React from "react";
import { useShallow } from "zustand/shallow";
import { JobProgress } from "./progress/job-progress";
import { JobProgressPortfolioCalculateValue } from "./progress/portfolio/job-progress-portfolio-calculate-values";

function renderJobProgressComponent(
  jobId: string,
  componentId: JobMeta["componentId"],
) {
  // TODO: Add more cases as needed
  switch (true) {
    case componentId === "portfolio-calculate-values":
      return <JobProgressPortfolioCalculateValue jobId={jobId} />;
    case componentId === "portfolio-create-exchange":
    case componentId === "portfolio-create-wallet":
    case componentId === "portfolio-sync-exchange":
    case componentId === "portfolio-sync-wallet":
    default:
      return <JobProgress jobId={jobId} />;
  }
}

export function Jobs() {
  const jobs = useJobsStore(useShallow((state) => state.jobs));
  const jobEntries = Array.from(jobs.entries());

  return (
    <>
      {jobEntries.map(([jobId, jobMeta]) => (
        <React.Fragment key={jobId}>
          {renderJobProgressComponent(jobId, jobMeta.componentId)}
        </React.Fragment>
      ))}
    </>
  );
}
